import gql from 'graphql-tag';

export const getContactListSchedules = gql`
  query getContactListSchedules($contactListId: String) {
    getContactListSchedules(contactListId: $contactListId) {
      id
      isPrimary
      startTime
      endTime
      timezone
      version
      contact {
        adAccountName
        firstName
        lastName
        id
      }
    }
  }
`;
